import { FieldRes } from './field-res'

export interface FieldGroupResInterface {
  domain?: string
  fields?: FieldRes[]
  /**
   * 问卷试用的字段
   */
  questionnaireFields?: FieldRes[]
  name: string
  weight?: number
  sortable?: boolean
  editable?: boolean
  /**
   * 主键 ID
   */
  id: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class FieldGroupRes implements FieldGroupResInterface {
  domain?: string
  fields?: FieldRes[]
  /**
   * 问卷试用的字段
   */
  questionnaireFields?: FieldRes[]
  name: string
  weight?: number
  sortable?: boolean
  editable?: boolean
  /**
   * 主键 ID
   */
  id: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: FieldGroupResInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      domain: _domain,
      fields: _fields,
      questionnaireFields: _questionnaireFields,
      name: _name,
      weight: _weight,
      sortable: _sortable,
      editable: _editable,
      id: _id,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.domain = _domain
    this.fields = _fields ? _fields.map((i) => new FieldRes(i)) : _fields
    this.questionnaireFields = _questionnaireFields
      ? _questionnaireFields.map((i) => new FieldRes(i))
      : _questionnaireFields
    this.name = _name
    this.weight = _weight
    this.sortable = _sortable
    this.editable = _editable
    this.id = _id
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
